import React, { useState } from "react";

export default function FaqSection({ items = [] }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!items.length) return null;

  return (
    <section className="container-app mx-auto">
      <div className="border border-gray-200 mt-4 rounded-lg divide-y divide-gray-200">
        {items.map((faq, idx) => (
          <div key={idx}>
            <button
              onClick={() => toggle(idx)}
              className="w-full text-left px-6 py-4 flex justify-between items-center focus:outline-none"
            >
              <span className="text-lg font-medium text-gray-900">{faq.question}</span>
              <span className="text-xl font-bold">
                {openIndex === idx ? "−" : "+"}
              </span>
            </button>

            {openIndex === idx && (
              <div className="px-6 pb-4 text-gray-700 text-sm leading-relaxed">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}